module.exports = __webpack_public_path__ + "img/yellow_stars.fff7e055.svg";